import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../../entries/common/request";
import { BaseApi } from "../../core/base-api";
import { makeDataMethod, makeMethod } from "../../core/base-api/methods-maker";
export var MePlaylistsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(MePlaylistsApi, _BaseApi);

  var _super = _createSuper(MePlaylistsApi);

  function MePlaylistsApi() {
    _classCallCheck(this, MePlaylistsApi);

    return _super.apply(this, arguments);
  }

  return MePlaylistsApi;
}(BaseApi);
/**
 * Create a new playlist
 */

MePlaylistsApi.prototype.create = makeDataMethod({
  method: 'post',
  path: Request.Me.Playlists.Paths.Create,
  needAuth: true
});
/**
 * Update a playlist
 */

MePlaylistsApi.prototype.update = makeDataMethod({
  method: 'put',
  path: Request.Me.Playlists.Paths.Update,
  needAuth: true
});
/**
 * delete playlist
 */

MePlaylistsApi.prototype.remove = makeMethod({
  method: 'delete',
  path: Request.Me.Playlists.Paths.Remove,
  needAuth: true
});
/**
 * add video to playlist
 */

MePlaylistsApi.prototype.addVideo = makeDataMethod({
  method: 'post',
  path: Request.Me.Playlists.Paths.AddVideo,
  needAuth: true
});
/**
 * remove video from playlist
 */

MePlaylistsApi.prototype.removeVideo = makeMethod({
  method: 'delete',
  path: Request.Me.Playlists.Paths.RemoveVideo,
  needAuth: true
});
/**
 * order videos in playlist
 */

MePlaylistsApi.prototype.orderVideos = makeDataMethod({
  method: 'post',
  path: Request.Me.Playlists.Paths.OrderVideos,
  needAuth: true
});